import { render, staticRenderFns } from "./CoordinatedAppointmentsnotCompleted.vue?vue&type=template&id=5453f708&"
import script from "./CoordinatedAppointmentsnotCompleted.vue?vue&type=script&lang=js&"
export * from "./CoordinatedAppointmentsnotCompleted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports